export class CrownTargetModel {
  id: Number;
  program_id: Number;
  created_by: Number;
  updated_by: Number;
  crown_target_status: Number;
  frequency_id: Number;
  frequency_name: String;
  is_trigger: Number;
  crown_target_img: any;
  crown_target_description: String;
  terms_conditions: String;
  eligibility: String;
  winner_message: String;
  winner_message_image: String;
  loser_message: String;
  loser_message_image: String;
  announcement_image: any;
  announcement_button_text: String;
  results_image: String;
  results_button_text: String;
  module_enabled: String;
  module_expired: String;
  created_date: String;
  updated_date: String;
  start_date: any;
  end_date: any;
  crown_target_title: String;
  sku_based: any;
  status: any;
  statusString: any;
  show: boolean;
  startDate: any;
  endDate: any;
}
